export default __webpack_public_path__ + "static/media/haxe.ff91c1f3.svg";